import React, { useState, useEffect } from 'react';
import CustomTitle from '../components/UI/title/CustomTitle';
import MyButton from '../components/UI/button/MyButton';
import { WithWizard } from 'react-albus-react18';
import axios from 'axios';
import mixpanel from 'mixpanel-browser';

const Website = ({ setButtonShow, setSelectedOption, setButtonSkip, sessionId, BusinessAreaHave }) => {

    // useEffect(() => {
    //     setSelectedOption('1')
    //     setButtonShow(false)
    //     setButtonSkip(false)
    // }, []);
    const [checkboxes, setCheckboxes] = useState({
        F: false,
    });
    const [errorUrl, setErrorUrl] = useState();
    const [name, setName] = useState('');

    const [error, setError] = useState(false);

    const areAllCheckboxesUnchecked = () => {
        return Object.values(checkboxes).every((isChecked) => !isChecked);
    };

    const [buttonStatus, setButtonStatus] = useState('');
    const handleClick = (next) => {


        if (areAllCheckboxesUnchecked()) {
            setError(true);
            setTimeout(() => {
                setError(false);
            }, 1000);
        } else {

            setButtonStatus('load')
            if (name.startsWith('https://') || name.startsWith('http://')) {
                checkWebsite(name, next);
            } else {
                checkWebsite(`https://${name}`, next);
            }
            setError(false);
        }


    };
    const handleInputChange = (event) => {
        const enteredValue = event.target.value.replace(/\s/g, '').toLowerCase();

  setName(enteredValue);
        setErrorUrl(false)
        if (event.target.value == "") {
            setCheckboxes({ F: false, })
        } else {
            setCheckboxes({ F: true, })
        }
    };

    function businessProfiles(value) {
        var profilesJSON = localStorage.getItem('business-profiles');
        if (profilesJSON) {
            var profiles = JSON.parse(profilesJSON);
            profiles.forEach(function (profile) {
                profile.siteDomain = value;
            });
            var updatedProfilesJSON = JSON.stringify(profiles);
            localStorage.setItem('business-profiles', updatedProfilesJSON);
        } else {
            var newProfile = {
                siteDomain: value
            };
            var newProfiles = [newProfile];
            var newProfilesJSON = JSON.stringify(newProfiles);
            localStorage.setItem('business-profiles', newProfilesJSON);
        }
    }

    const businessProfilesUpdate = (url) => {
        const fullJSON = localStorage.getItem('business-profiles');
        const profile = JSON.parse(fullJSON)[0];
        const trimmedJSON = JSON.stringify(profile);

        const data = trimmedJSON

        axios.get("https://staging.zeely.link/business-profiles", {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
            },
            redirect: 'follow'
        })

            .then(response => {
                localStorage.setItem('business-profiles-id', response.data.data.id);
                axios.patch(`https://staging.zeely.link/business-profiles/${response.data.data.id}`, data, {
                    headers: {
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
                    },
                    redirect: 'follow'
                })
                    .then(response => {
                        // CreateSite(next, true)
                    })
                    .catch(error => {

                        sendAlert(`https://staging.zeely.link/business-profiles/${localStorage.getItem('business-profiles-id')}`, data, error.response.data.message)
                        console.log(error)
                        console.log(error)
                    });
            })
            .catch(error => {
                console.log(error)

            });


    };


    function checkWebsite(url, next) {

        const data = JSON.stringify({ url: url })
        axios.post(`https://staging.zeely.link/sites/check-user-site`, data, {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
            },
            redirect: 'follow'
        })
            .then(response => {
                console.log(response.data.status)
                if (response.data.status === true) {
                    businessProfiles(url)
                    businessProfilesUpdate(url)
                    Scraper(url)
                    mixpanel.track('web_websiteurl', {
                        web_entrance: localStorage.getItem('signupMethod') === "Login" ? 'login' : 'signup',
                        session_id: sessionId,
                        web_level: localStorage.getItem('web_booster_pay') === true ? 'GROWTH' : 'TRIAL',
                        web_plan__name: localStorage.getItem('plan'),
                        user_id: localStorage.getItem('userId'),
                        web_website_act: url,
                        web_utm_campaign: localStorage.getItem("utmCampaign"),
                        web_utm_source: localStorage.getItem("utmSource"),
                        web_utm_medium: localStorage.getItem("utmMedium"),
                        web_utm_content: localStorage.getItem("utmContent"),
                        web_utm_term: localStorage.getItem("utmTerm"),
                        isDebug: false,
funnel: 'MAIN_v1',
                    });
                    next()
                } else {
                    setButtonStatus('')
                    setErrorUrl(true)
                }
            })
            .catch(error => {
                console.log(error.message)
                if(error.message === "Network Error" && url.includes('www.')) {

                    checkWebsite(removeWWW(url), next)
                } else {
                    let errorMessage = error;
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
    
                    sendAlert(`https://staging.zeely.link/sites/check-user-site`, data, errorMessage);
                    setButtonStatus('')
                    setErrorUrl(true)
                }
            
            });


    }

    function removeWWW(url) {
        return url.replace('www.', ''); // or 'https://' if you prefer to maintain https
    }

    const Scraper = (url) => {
        // const trimmedJSON = JSON.stringify({
        //     'url': name,
        //     'structure': localStorage.getItem('structure'),
        // });

        // const data = trimmedJSON
        const structure = localStorage.getItem('structure') ? localStorage.getItem('structure').toUpperCase() : 'OTHER'

        axios.get(`https://staging.zeely.link/users/scraper?url=${url}&structure=${structure}`, {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
            },
            redirect: 'follow'
        })
            .then(response => {
                // localStorage.setItem('site-id', response.data.data.id);
            })
            .catch(error => {
                sendAlert(`https://staging.zeely.link/users/scraper?url=${url}&structure=${structure}`, '', error.response.data.message)
                console.log(error)
            });
    };


    const UpdateSite = (url) => {
        const trimmedJSON = JSON.stringify({
            'url': url,
            'type': localStorage.getItem('direction') ? localStorage.getItem('direction').toLowerCase() : 'product'
        });

        const data = trimmedJSON

        axios.post("https://staging.zeely.link/sites", data, {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
            },
            redirect: 'follow'
        })
            .then(response => {
                // localStorage.setItem('site-id', response.data.data.id);
                // next()
            })
            .catch(error => {
                console.log(error)
                // next()
            });
        // const trimmedJSON = JSON.stringify({
        //     "isActive": true
        // });
        // const data = trimmedJSON
        // axios.patch(`https://staging.zeely.link/sites/${localStorage.getItem('site-id')}`, data, {
        //     headers: {
        //         "Content-Type": "application/json",
        //         'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        //     },
        //     redirect: 'follow'
        // })
        //     .then(response => {
        //         localStorage.setItem('site-id', response.data.data.id);
        //     })
        //     .catch(error => {
        //         console.log(error)
        //     });
    };



    const sendAlert = async (path, data, errorLog) => {
        const now = new Date();
        const utcString = now.toISOString();

        const formdata = new FormData();
        formdata.append("domain", window.location.hostname);
        formdata.append("time", utcString);
        formdata.append("email", localStorage.getItem('email'));
        formdata.append("path", path);
        formdata.append("data", data);
        formdata.append("error", errorLog);
        console.log(formdata)
        try {
            const response = await axios.post("https://zee.sale/send-alert.php", formdata, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            console.log(response.data);
        } catch (error) {
            console.error(error);
        }
    };


    return (
        <div>

            <div className="brandname-top">
                <svg width="150" height="32" viewBox="0 0 150 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="65" width="85" height="32" rx="16" fill="#5BF0A5" />
                    <path d="M80.3333 17.9993H77L81.6667 8.66602V13.9993H85L80.3333 23.3327V17.9993Z" fill="black" />
                    <path d="M97.544 18.656C98.3 18.656 98.9673 18.4553 99.546 18.054C100.125 17.6433 100.517 17.0973 100.722 16.416H97.544V15.1H102.5C102.5 16.5093 102.024 17.6993 101.072 18.67C100.129 19.6313 98.9487 20.112 97.53 20.112C96.1207 20.112 94.94 19.65 93.988 18.726C93.0453 17.802 92.574 16.6493 92.574 15.268C92.574 13.8867 93.05 12.7247 94.002 11.782C94.9633 10.8393 96.1393 10.368 97.53 10.368C98.566 10.368 99.4993 10.6387 100.33 11.18C101.17 11.7213 101.772 12.4493 102.136 13.364H100.358C100.059 12.8787 99.6627 12.5007 99.168 12.23C98.6733 11.95 98.132 11.81 97.544 11.81C96.6107 11.81 95.822 12.1413 95.178 12.804C94.5433 13.4667 94.226 14.2787 94.226 15.24C94.226 16.2013 94.5433 17.0133 95.178 17.676C95.822 18.3293 96.6107 18.656 97.544 18.656ZM105.398 15.814V20H103.872V13.056H105.356V13.756C105.534 13.4853 105.753 13.28 106.014 13.14C106.276 12.9907 106.57 12.916 106.896 12.916C107.111 12.916 107.307 12.944 107.484 13C107.671 13.056 107.82 13.1353 107.932 13.238L107.162 14.582C107.06 14.5167 106.952 14.47 106.84 14.442C106.738 14.414 106.635 14.4 106.532 14.4C106.178 14.4 105.898 14.5307 105.692 14.792C105.496 15.044 105.398 15.3847 105.398 15.814ZM111.605 12.916C112.631 12.916 113.495 13.2613 114.195 13.952C114.895 14.6427 115.245 15.4967 115.245 16.514C115.245 17.5313 114.895 18.3853 114.195 19.076C113.495 19.7667 112.631 20.112 111.605 20.112C110.578 20.112 109.715 19.7667 109.015 19.076C108.315 18.3853 107.965 17.5313 107.965 16.514C107.965 15.4967 108.315 14.6427 109.015 13.952C109.715 13.2613 110.578 12.916 111.605 12.916ZM109.505 16.514C109.505 17.13 109.705 17.648 110.107 18.068C110.517 18.488 111.017 18.698 111.605 18.698C112.183 18.698 112.678 18.488 113.089 18.068C113.499 17.6387 113.705 17.1207 113.705 16.514C113.705 15.9073 113.499 15.394 113.089 14.974C112.678 14.5447 112.183 14.33 111.605 14.33C111.017 14.33 110.517 14.54 110.107 14.96C109.705 15.38 109.505 15.898 109.505 16.514ZM126.256 13.056L123.946 20H122.49L120.908 15.31H120.866L119.214 20H117.772L115.574 13.056H117.17L118.668 17.9H118.71L120.362 13.056H121.524L123.078 17.872H123.148L124.702 13.056H126.256ZM130.262 18.642V20H129.478C128.778 20 128.279 19.846 127.98 19.538C127.682 19.23 127.532 18.712 127.532 17.984V14.386H126.566V13.056H127.532V11.32H129.058V13.056H130.248V14.386H129.058V17.732C129.058 18.0867 129.119 18.3293 129.24 18.46C129.362 18.5813 129.581 18.642 129.898 18.642H130.262ZM137.205 15.366V20H135.679V15.604C135.679 15.2027 135.553 14.8853 135.301 14.652C135.058 14.4093 134.732 14.288 134.321 14.288C133.901 14.288 133.551 14.414 133.271 14.666C133 14.9087 132.865 15.2167 132.865 15.59V20H131.339V10.48H132.865V13.854C133.061 13.5647 133.327 13.336 133.663 13.168C133.999 13 134.377 12.916 134.797 12.916C135.544 12.916 136.132 13.1353 136.561 13.574C136.99 14.0127 137.205 14.61 137.205 15.366Z" fill="black" />
                    <g clip-path="url(#clip0_9645_75617)">
                        <path d="M25.8492 16.0474C25.8245 14.1976 25.2074 12.6685 23.973 11.4599C22.7387 10.2761 21.1835 9.68415 19.2826 9.68415C17.3818 9.68415 15.8019 10.2761 14.5676 11.4599C13.3086 12.6685 12.6914 14.1729 12.6914 16.0227C12.6914 17.8725 13.3086 19.377 14.5676 20.5608C15.8019 21.7447 17.3818 22.3366 19.2826 22.3366C20.7885 22.3366 22.1463 21.9173 23.3312 21.0541C24.5161 20.1909 25.2814 19.1057 25.627 17.7738H22.3931C21.9241 18.8837 20.7145 19.7223 19.3073 19.7223C17.6287 19.7223 16.2956 18.6124 15.9006 17.0093H25.7505C25.8245 16.738 25.8492 16.4173 25.8492 16.0474ZM19.3073 12.2985C20.8626 12.2985 22.2203 13.2111 22.714 14.5676H16.0241C16.5425 13.1864 17.8015 12.2985 19.3073 12.2985Z" fill="black" />
                        <path d="M39.8384 16.0474C39.8137 14.1976 39.1966 12.6685 37.9623 11.4599C36.728 10.2761 35.1727 9.68415 33.2719 9.68415C31.371 9.68415 29.7911 10.2761 28.5568 11.4599C27.2978 12.6685 26.6806 14.1729 26.6806 16.0227C26.6806 17.8725 27.2978 19.377 28.5568 20.5608C29.7911 21.7447 31.371 22.3366 33.2719 22.3366C34.7777 22.3366 36.1355 21.9173 37.3204 21.0541C38.5054 20.1909 39.2706 19.1057 39.6162 17.7738H36.3823C35.9133 18.8837 34.7037 19.7223 33.2966 19.7223C31.6179 19.7223 30.2848 18.6124 29.8898 17.0093H39.7397C39.8137 16.738 39.8384 16.4173 39.8384 16.0474ZM33.2966 12.2985C34.8518 12.2985 36.2095 13.2111 36.7033 14.5676H30.0133C30.5317 13.1864 31.7907 12.2985 33.2966 12.2985Z" fill="black" />
                        <path d="M41.3364 22.1146H44.5456V4.99805H41.3364V22.1146Z" fill="black" />
                        <path d="M52.2983 17.6012L48.8915 9.93078H45.4602L50.7924 20.8075L47.6572 26.998H51.0146L58.9882 9.93078H55.6309L52.2983 17.6012Z" fill="black" />
                        <path d="M8.87406 9.92969H12.542L4.13667 22.1139H0.46875L8.87406 9.92969Z" fill="black" />
                        <path d="M0.800781 9.92969H9.80355V12.6771H0.800781V9.92969Z" fill="black" />
                        <path d="M3.2793 19.3652H11.9358V22.1127H3.2793V19.3652Z" fill="black" />
                    </g>
                    <defs>
                        <clipPath id="clip0_9645_75617">
                            <rect width="59" height="22" fill="white" transform="translate(0 5)" />
                        </clipPath>
                    </defs>
                </svg>
                <div className="brandname-top-right">{BusinessAreaHave+1}/{BusinessAreaHave+1}</div>
               
            </div>
            <CustomTitle style={{ marginBottom: "12rem" }} title="Great! Please enter your website URL" />
            <p style={{ marginBottom: "24rem" }} className="text">We will automatically integrate it with Zeely</p>
            <div className={`input ${errorUrl ? 'error' : ''}`} style={{ marginBottom: "24rem" }}>
                <input
                    type="text" placeholder='Enter URL'
                    value={name}
                    onChange={handleInputChange}

                />
                {errorUrl && (
                    <div className="error-text">This domain name is unavailable. Try a different one.</div>
                )}

                {/* <div className="input-ai">
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.6088 8.50259L13.9913 6.58984L14.3739 8.50259C15.0804 12.0353 17.8418 14.7968 21.3746 15.5033L23.2873 15.8858L21.3746 16.2684C17.8418 16.9749 15.0804 19.7364 14.3739 23.2691L13.9913 25.1818L13.6088 23.2691C12.9022 19.7364 10.1408 16.9749 6.60806 16.2684L4.69531 15.8858L6.60806 15.5033C10.1408 14.7968 12.9022 12.0353 13.6088 8.50259Z" fill="black" />
                        <path d="M5.71537 1.42766L5.92512 0.378906L6.13487 1.42766C6.52229 3.36465 8.03634 4.87874 9.97336 5.26615L11.0221 5.4759L9.97336 5.68566C8.03634 6.07303 6.52229 7.58712 6.13487 9.52414L5.92512 10.5729L5.71537 9.52414C5.32796 7.58712 3.81386 6.07303 1.87688 5.68566L0.828125 5.4759L1.87688 5.26615C3.81386 4.87874 5.32796 3.36465 5.71537 1.42766Z" fill="black" />
                        <path d="M21.3189 4.01865L21.471 3.25781L21.6232 4.01865C21.9042 5.42384 23.0026 6.52221 24.4078 6.80326L25.1687 6.95546L24.4078 7.1076C23.0026 7.38865 21.9042 8.48702 21.6232 9.89222L21.471 10.6531L21.3189 9.89222C21.0378 8.48702 19.9395 7.38865 18.5343 7.1076L17.7734 6.95546L18.5343 6.80326C19.9395 6.52221 21.0378 5.42384 21.3189 4.01865Z" fill="black" />
                    </svg>

                </div> */}
            </div>

            <WithWizard
                render={({ next, previous, step, steps }) => (
                    <>
                        <MyButton
                            // ref={nextPageButtonRef}
                            buttonStatus={buttonStatus}
                            buttonTime={"0"}
                            buttonText={"Continue"}
                            onClick={() => handleClick(next)}
                            className={(areAllCheckboxesUnchecked()) ? (error ? 'error' : 'disable') : undefined}
                        >
                        </MyButton>
                        <div className="skip" onClick={() => {
                            mixpanel.track('web_websiteurl', {
                                web_entrance: localStorage.getItem('signupMethod') === "Login" ? 'login' : 'signup',
                                session_id: sessionId,
                                web_level: localStorage.getItem('web_booster_pay') === true ? 'GROWTH' : 'TRIAL',
                                web_plan__name: localStorage.getItem('plan'),
                                user_id: localStorage.getItem('userId'),
                                web_website_act: 'skip',
                                web_utm_campaign: localStorage.getItem("utmCampaign"),
                                web_utm_source: localStorage.getItem("utmSource"),
                                web_utm_medium: localStorage.getItem("utmMedium"),
                                web_utm_content: localStorage.getItem("utmContent"),
                                web_utm_term: localStorage.getItem("utmTerm"),
                                isDebug: false,
funnel: 'MAIN_v1',
                            });
                            next()
                        }}>
                            Skip
                        </div>

                    </>

                )}
            />



        </div>
    );
}

export default Website;

